import React from "react";
import MasterDataContextType from "../../../domain/providers/master_data/master_data_context_type";

export const defaultMasterDataContext: MasterDataContextType = {
    typesCall: [],
    setTypesCall: () => {}
};
const MasterDataContext = React.createContext<MasterDataContextType>(defaultMasterDataContext);

export default MasterDataContext;